import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Card": Card, "@mui/material/CardHeader": CardHeader, "@mui/material/CardContent": CardContent, "@mui/material/CardMedia": CardMedia, "@mui/material/Avatar": Avatar, "@mui/material/Typography": Typography, "@mui/material/IconButton": IconButton, "@mui/icons-material/MoreVert": MoreVertIcon, "@mui/material/Skeleton": Skeleton } } });
export default ClientProvider;
